export const versions = { version: '1.0.1322' }



// WEBPACK FOOTER //
// ./client/app/services/versions.js